export default __webpack_public_path__ + "static/media/fastcat.b92b2083.png";